export default "https://cdn-static.gokick.com/assets/be369b33e14920b1856d71de34d484ec78759d8a/images/gokick-home-thumb.d0805bfbe5c122bc4415664ec8f6d56b.png";